import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  const scrollToMoney = () => {
    document.getElementById('money-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-10 px-5 bg-white" data-id="element-188">
      <div className="max-w-2xl mx-auto text-center" data-id="element-189">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }} data-id="element-190">
          <motion.h2 variants={fadeUp} className="font-serif text-3xl md:text-4xl text-charcoal mb-6" data-id="element-191">
            Imagine this instead…
          </motion.h2>

          <motion.div variants={fadeUp} className="space-y-4 text-lg md:text-xl text-charcoal-light leading-relaxed mb-8" data-id="element-192">
            <p data-id="element-193">You wake up…</p>
            <p data-id="element-194">
              And your body feels calm. Not forced. Not fragile. Just… steady.
            </p>
            <p data-id="element-195">
              Your mind is quieter. Your reactions soften. You handle things
              without spiraling.
            </p>
            <p data-id="element-196">And for the first time in a long time…</p>
          </motion.div>

          <motion.div variants={fadeUp} className="bg-cream p-5 md:p-6 rounded-2xl mb-8 shadow-sm border border-sand" data-id="element-197">
            <p className="font-serif text-2xl md:text-3xl text-terracotta" data-id="element-198">
              "I finally feel in control again."
            </p>
          </motion.div>

          <motion.div variants={fadeUp} data-id="element-199">
            <motion.button onClick={scrollToMoney} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto bg-terracotta hover:bg-terracotta-dark text-white font-semibold text-base md:text-lg py-3.5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-200">
              Reset My Nervous System Now
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}